import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ciudad } from '../domain/ciudad';
import { GLOBAL } from '../global';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  urlBase: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  /**
   * @author Frank Edward Daza González
   * @version 2018-10-30
   * @param httpClient
   */
  constructor(private httpClient: HttpClient) {
    this.urlBase = GLOBAL.URL_SIGAMOS + 'sicaCity';
  }

  /**
    * Retorna las ciudades del servicio REST de SIGAMOS.
    * 
    * @author Frank Edward Daza González
    * @version 2018-10-30
    */
   getCitiesByProvId(ciudad: Ciudad): Observable<any> {
    return this.httpClient.post(this.urlBase + '/getCitiesByProvId', ciudad, this.httpOptions);
  }
  
}
